// IE9+
function ready(fn) {
  if (document.readyState != 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}
ready(function() {
  const myDiv = document.querySelector(".order-summary__sections");

  // different payment types
  const vsxRent = document.querySelector('#vsx_rent');
  const vsxBuy = document.querySelector('#vsx_buy');
  const vsxQuantity = document.querySelector("#quantity");
  
  const ssdRent = document.querySelector('#ssd_rent');
  const triggerRent = document.querySelector('#trigger_rent');
  const ssdBuy = document.querySelector('#ssd_buy');
  const triggerBuy = document.querySelector('#trigger_buy');

  const totalLabelCss = document.querySelector(".payment-due-label__total");
  const totalPriceCss = document.querySelector(".payment-due__price");

  // split right secion dom
  const split = document.createElement("DIV");
  split.classList.add("my-class");
  const title = document.createElement("H2");
  title.classList.add("split-title");
  const videoCtn = document.createElement("DIV");
  videoCtn.classList.add("video-ctn");

  // split left section dom
  const mainContent = document.querySelector(".step__sections");
  const financeCtn = document.createElement("DIV");
  financeCtn.classList = "financing-callout";
  const splitLeft = document.createElement("DIV");
  splitLeft.classList.add("finance-callout-container");
  const financeOption1 = document.createElement("DIV");
  const financeOption2 = document.createElement("DIV");
  financeOption1.className = "finance-copy finance-looking";
  financeOption2.className = "finance-copy finance-select";
  const imageCtn = document.createElement("DIV");
  imageCtn.className = "financing-options";
  const splitLogo = document.createElement("IMG");
  splitLogo.src = "https://cdn.shopify.com/s/files/1/0266/1649/6190/t/1/assets/split-logo.png?v=1602191851";

  // price modifications
  const totalPriceCtn = document.querySelector(".payment-due");
  const totalPrice = document.querySelector(".payment-due__currency");
  const totalLabel = document.querySelector(".payment-due-label");
  const monthly = document.createElement("DIV");
  const monthlySub = document.createElement("P");
  const monthlySub2 = document.createElement("SPAN");
  monthlySub.classList = "monthly-label";
  monthly.classList = "monthly-payment";

  const pricingTitle = "Grand Total";
  const pricingSub = " for 12 Months";

  // video links
  const VSX_VIDEO = "//www.youtube.com/watch?v=9GrZ-R8u4A4";
  const SSD_VIDEO = "//www.youtube.com/watch?v=Ph5eaRELZY8";
  const TRIGGER_VIDEO = "//www.youtube.com/watch?v=KAPXnucaTeI";

  // video links
  const videoLink = document.createElement("a");
  const videoText = document.createTextNode("Watch this video to see how Splitit works.");
  videoLink.appendChild(videoText);
  videoLink.setAttribute('data-lity', '');

  // edit main price
  const productPriceCtn = document.querySelector('.product__price');
  const mainPrice = productPriceCtn.children[0];

  const productPriceToInt = parseFloat(totalPriceLiq.split("$").join(''));
  let productRTOPrice = (productPriceToInt / 12 ).toFixed(3);
  productRTOPrice = productRTOPrice.substring(0, productRTOPrice.length - 1);
  const splitLeftTitleAll = `We've partnered with Splitit for the $${productRTOPrice} rent to own option.`; 

  const mobilePrice = document.querySelector(".total-recap__final-price");
  const drumsTotalDiscountCtn = document.querySelector('.total-line-table');

  var disucountApplied = sessionStorage.getItem("discount");

  // coming from util file
  addDrumsNotice();
  
  function addSplitLeft(vidLink) {
    imageCtn.appendChild(splitLogo);
    financeOption1.innerHTML = splitLeftTitleAll;
    videoLink.href = vidLink;
    financeOption2.appendChild(videoLink);
    splitLeft.appendChild(financeOption1);
    splitLeft.appendChild(imageCtn);
    splitLeft.appendChild(financeOption2);
    financeCtn.appendChild(splitLeft);
    mainContent.insertBefore(financeCtn, mainContent.firstChild);
  }

  function addPricing(monthlyPrice) {
    monthlySub.innerHTML = pricingTitle;
    monthlySub2.innerHTML = pricingSub;
    if (vsxQuantity) {
      monthly.classList += " split-price"
      monthly.innerHTML = "$" + (vsxQuantity.value * monthlyPrice).toFixed(2);
    } else {
      monthly.innerHTML = monthlyPrice;
    }
    
    totalLabel.appendChild(monthlySub);
    monthly.appendChild(monthlySub2);
    totalPriceCtn.appendChild(monthly);
  }
  
  if (vsxRent) {
    const vsxRTOPrice = "$" + (vsxQuantity.value * 39.99).toFixed(2);
    addPricing(39.99);
    addSplitLeft(VSX_VIDEO);
    mainPrice.innerHTML = vsxRTOPrice;
    mobilePrice.innerHTML = vsxRTOPrice;
    totalLabelCss.classList.add("show-total");
    totalPriceCss.classList.add("show-total");    
  } else if (vsxBuy) {
    addSplitLeft(VSX_VIDEO);
    totalLabelCss.classList.add("show-total");
    totalPriceCss.classList.add("show-total");
  } 
//   else if (ssdBuy) {
//     addSplitLeft(SSD_VIDEO);
//   } else if (triggerBuy) {
//     addSplitLeft(TRIGGER_VIDEO);
//   }

  if (!disucountApplied) {
    if (ssdRent) {
      addPricing("$" + productRTOPrice);
      addSplitLeft(SSD_VIDEO);
      mainPrice.innerHTML = "$" + productRTOPrice;
      mobilePrice.innerHTML = "$" + productRTOPrice;
      drumsTotalDiscountCtn.classList.add('not-vis');
    } else if (triggerRent) {
      addPricing("$" + productRTOPrice);
      addSplitLeft(TRIGGER_VIDEO);
      mainPrice.innerHTML = "$" + productRTOPrice;;
      mobilePrice.innerHTML = "$" + productRTOPrice;;
      drumsTotalDiscountCtn.classList.add('not-vis');
    } 
  } else {
    monthlySub.innerHTML = pricingTitle;
    monthlySub2.innerHTML = pricingSub;
    drumsTotalDiscountCtn.classList.add('not-vis');
  }
  
  if (ssdRent || triggerRent) {
    setTimeout(() => {
      var intervalId = window.setInterval(function(){
        /// call your function here
        const productPriceCtn = document.querySelector('.product__price');
        let price = productPriceCtn.children[0];

      	if (convertToNum(price.innerHTML) !== convertToNum(productRTOPrice) ) {
          const drumsTotalDiscountCtn = document.querySelector('.total-line-table');
          const priceDue = document.querySelector('.payment-due__price');
          sessionStorage.setItem('discount', 'y');
          let priceStr = "$" + (convertToNum(priceDue.innerHTML) / 12 ).toFixed(3);
          priceStr = priceStr.substring(0, priceStr.length -1);
          price.innerHTML = priceStr;
          productRTOPrice = priceStr;
          const totalPriceCtn = document.querySelector(".payment-due");
          const totalLabel = document.querySelector(".payment-due-label");
          
          monthly.innerHTML = priceStr;
          totalLabel.appendChild(monthlySub);
          monthly.appendChild(monthlySub2);
          totalPriceCtn.appendChild(monthly);
          drumsTotalDiscountCtn.classList.add('not-vis');
          const mainContent = document.querySelector(".step__sections");
          function addSplitLeft2(vidLink) {
            imageCtn.appendChild(splitLogo);
            financeOption1.innerHTML = splitLeftTitleAll;
            videoLink.href = vidLink;
            financeOption2.appendChild(videoLink);
            splitLeft.appendChild(financeOption1);
            splitLeft.appendChild(imageCtn);
            splitLeft.appendChild(financeOption2);
            financeCtn.appendChild(splitLeft);
            mainContent.insertBefore(financeCtn, mainContent.firstChild);
            const mainHeader = document.querySelector(".layout-flex__item--stretch");
            if (mainHeader) {
              const drumsNotice1 = document.createElement("P");
              const drumsNotice2 = document.createElement("P");
              drumsNotice1.classList.add("note-text");
              drumsNotice2.classList.add("note-text");
              const drumsCopy1 = document.createTextNode("Note: Drum products will be registered to this email address automatically.");
              const drumsCopy2 = document.createTextNode("Use your primary email or Steven Slate Audio account email address here.");
              drumsNotice1.appendChild(drumsCopy1);
              drumsNotice2.appendChild(drumsCopy2);
              mainHeader.parentNode.appendChild(drumsNotice1);
              mainHeader.parentNode.appendChild(drumsNotice2);
            }
          }
          
          if (ssdRent) {
            addSplitLeft2(SSD_VIDEO);
          } else {
            addSplitLeft2(TRIGGER_VIDEO);
          }
        }
      }, 500);
    }, 100);
  }

  mainPrice.classList.add("show");

});